import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ModusButtonModule, ModusIconModule, ModusTooltipModule } from '@trimble-gcs/modus';
import { DownloadProgress, DownloadStatus } from '../download.models';
import { downloadProgressTranslations } from './download-progress.translations';

@UntilDestroy()
@Component({
  selector: 'sd-download-progress',
  imports: [
    CommonModule,
    ModusTooltipModule,
    ModusButtonModule,
    ModusIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './download-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadProgressComponent {
  readonly translations = downloadProgressTranslations();
  readonly downloadStatus = DownloadStatus;

  readonly progress = input<DownloadProgress>();
  readonly progressTooltip = input<string, string | undefined>('', {
    transform: (value) => value ?? '',
  });
}
